/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Addsvc API
 * Addsvc 서비스용 API 문서
 * OpenAPI spec version: 1.0
 */

/**
 * 부가서비스 상태
 */
export type AddsvcStatus = (typeof AddsvcStatus)[keyof typeof AddsvcStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddsvcStatus = {
  U: 'U',
  C: 'C',
  E: 'E',
} as const;
